

const initialState = {
	login: null,
	ipdata: null
};


const reducerLogin = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_LOGIN':
			return {
				login: action.login
			};
		case 'SET_LOGIN_IPDATA':
			return {
				...state,
				ipdata: action.ipdata
			};
		default:
			return state;
	}
};

export default reducerLogin;
